import { RiLinkM } from "react-icons/ri";
import Button from "@/Utility/Button/Button";
import FloatingTooltip from "@/Utility/FloatingTooltip/FloatingTooltip";
import "./issueDetail.css";

export const COPY_WORK_ITEM_LINK_TOOLTIP = "Copy link to work item";

export default function WorkItemCopyLinkButton({ onClick, className = "" }) {
  return (
    <FloatingTooltip label={COPY_WORK_ITEM_LINK_TOOLTIP}>
      <Button
        type="button"
        variant="icon"
        size="vsm"
        className={`work-item-copy-link-btn ${className}`.trim()}
        onClick={onClick}
        aria-label={COPY_WORK_ITEM_LINK_TOOLTIP}
      >
        <RiLinkM className="text-base" aria-hidden />
      </Button>
    </FloatingTooltip>
  );
}
